import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ConstantService {

  protected static woa = '/woa/v1/';

  protected static get woa_url(): string {
    // const url = location.hostname.split('.');
    // let tenant = '';
    // if (url.length > 1) {
    //   tenant = `${url[0]}.`;
    // }

    return environment.backEnd;
    // return 'https://backendsapo.sys-nova.com';
  }


  // TODO MEGA SAPO

  public static get PROJECT_URL(): string { return this.woa_url + this.woa + 'project/'; }
  public static get USERS_REALMS(): string { return this.woa_url + this.woa + 'executive/'; }
  public static get AGENCY_URL(): string { return this.woa_url + this.woa + 'agency/'; }
  public static get REWARD_URL(): string { return this.woa_url + this.woa + 'reward/'; }
  public static get AWARDS_URL(): string { return this.woa_url + this.woa + 'awards/'; }
  public static get MEMBERSHIP_URL(): string { return this.woa_url + this.woa + 'membership/'; }
  public static get COOP_MEMBERSHIPS_URL(): string { return this.woa_url + this.woa + 'coop/memberships'; }
  public static get CHANNEL_PROJECT_URL(): string { return this.woa_url + this.woa + 'projectChannel/'; }
  public static get CHANNEL_URL(): string { return this.woa_url + this.woa + 'channel/'; }
  public static get CAUSAL_URL(): string { return this.woa_url + this.woa + 'causal/'; }
  public static get MENUS_URL(): string { return this.woa_url + this.woa + 'menu/'; }
  public static get MODULES_URL(): string { return this.woa_url + this.woa + 'module/'; }


  public static get MANAGEMENT_URL(): string { return this.woa_url + this.woa + 'managementType/'; }
  public static get COVERAGE_URL(): string { return this.woa_url + this.woa + 'coverage/'; }
  public static get APIS_URL(): string { return this.woa_url + this.woa + 'apis/'; }
  public static get PARENT_URL(): string { return this.woa_url + this.woa + 'beneficiaryTypes/'; }
  public static get DOCUMENT_TYPE_URL(): string { return this.woa_url + this.woa + 'documentType/'; }
  public static get FILES_URL(): string { return this.woa_url + this.woa + 'files/'; }
  public static get BROKER_URL(): string { return this.woa_url + this.woa + 'gm/'; }
  public static get EXECUTIVE_URL(): string { return this.woa_url + this.woa + 'executive/'; }
  public static get AWARD_EXECUTIVE_URL(): string { return this.woa_url + this.woa + 'awardExecutive/'; }

  public static get PRODUCT_URL(): string { return this.woa_url + this.woa + 'product/'; }
  public static get POLICY_URL(): string { return this.woa_url + this.woa + 'policy/'; }
  public static get PLAN_URL(): string { return this.woa_url + this.woa + 'plan/'; }
  public static get PLAN_ANEXOS_URL(): string { return this.woa_url + this.woa + 'planAnexos/'; }
  public static get INSURABILITY_FORM_DEFINITION_URL(): string { return this.woa_url + this.woa + 'insurability-form-definition/'; }
  public static get INSURABILITY_RESPONSE_URL(): string { return this.woa_url + this.woa + 'insurability-response/'; }
  public static get APPORTIONMET_URL(): string { return this.woa_url + this.woa + 'apportionment/'; }
  public static get COVERAGE_PLAN_URL(): string { return this.woa_url + this.woa + 'coveragePlan/'; }
  public static get CUSTOMER_PLAN_URL(): string { return this.woa_url + this.woa + 'customer/'; }
  public static get CONDITION_URL(): string { return this.woa_url + this.woa + 'condition/'; }
  public static get CUSTOMER_URL(): string { return this.woa_url + this.woa + 'customer/'; }

  public static get REPORT_URL(): string { return this.woa_url + this.woa + 'report/'; }
  public static get MDA_GENERATE_PDF_PREVIEW_URL(): string { return this.woa_url + '/woa/api/gdocs/mda/generate-pdf/preview'; }
  public static get DESGRAVAMEN_DOCUMENTS_URL(): string {
    return this.woa_url + '/woa/api/gdocs/desgravamen/reprocess-by-id-all-rules/documents';
  }
  public static get AUDIT_URL(): string { return this.woa_url + this.woa + 'audit/'; }

  public static get GROUP_PERMISSION_URL(): string { return this.woa_url + this.woa + 'groupPermission/'; }
  public static get NOTIFICATION_URL(): string { return this.woa_url + this.woa + 'notification/'; }

  public static get DOWNLOAD_DOCUMENTS_LOG_URL(): string { return this.woa_url + this.woa + 'download-documents_log/'; }
  public static get VERIFICATION_PINS_URL(): string { return this.woa_url + this.woa + 'verification-pins/'; }
  public static get DOCUMENT_DEFINITION_URL(): string { return this.woa_url + this.woa + 'document-definition/'; }
  public static get REGISTERED_INSURERS_URL(): string { return this.woa_url + '/woa/api/grupoMancheno/aseguradoras-registradas'; }
  public static get ECUABUSQUEDA_IDENTIFICATION_URL(): string { return this.woa_url + '/woa/api/ecuabusqueda/identification'; }
  /////DESGRAVAMEN

  public static get INSURANCE_ACCEPTANCE_URL(): string { return this.woa_url + this.woa + 'insuranceAcceptance/'; }
  public static get INSURANCE_CONSULT_URL(): string { return this.woa_url + this.woa + 'insuranceConsult/'; }

 
  constructor() { }
}
